import { normalizeStringTags } from './normalizeStringTags.js';
const INTERNAL_ATTRIBUTE_PREFIX = /^(guided_shot|shot_id|shot|template|prompt):/i;
const GENERIC_PHOTO_DESCRIPTION = /^(job photo:\s*)/i;
const SERVICEFLOW_PHOTO_NAME = /^serviceflow_photo_/i;
const FILENAME_ONLY = /\.(jpe?g|png|heic|webp|gif)$/i;
export function isInternalPhotoAttribute(label) {
    return INTERNAL_ATTRIBUTE_PREFIX.test(label.trim());
}
export function isGenericPhotoDescription(text) {
    const trimmed = text.trim();
    if (!trimmed)
        return true;
    if (GENERIC_PHOTO_DESCRIPTION.test(trimmed))
        return true;
    if (SERVICEFLOW_PHOTO_NAME.test(trimmed))
        return true;
    if (FILENAME_ONLY.test(trimmed) && !trimmed.includes(' '))
        return true;
    return false;
}
export function formatPhotoAttributeLabel(label) {
    const trimmed = label.trim();
    const lower = trimmed.toLowerCase();
    if (lower === 'before' || lower === 'during' || lower === 'after') {
        return lower.charAt(0).toUpperCase() + lower.slice(1);
    }
    return trimmed;
}
export function photoAttributeLabels(source) {
    const tags = normalizeStringTags(source.tags);
    const extras = [source.phase, source.jobPhotoCategory, source.category]
        .filter((value) => typeof value === 'string' && value.trim().length > 0)
        .map((value) => value.trim());
    return [...new Set([...tags, ...extras])]
        .filter((label) => !isInternalPhotoAttribute(label))
        .map(formatPhotoAttributeLabel);
}
export function jobPhotoReportCaption(source) {
    const notes = typeof source.description === 'string' ? source.description.trim() : '';
    if (notes && !isGenericPhotoDescription(notes))
        return notes;
    const attributes = photoAttributeLabels(source);
    return attributes[0] || '';
}
export function jobPhotoDisplayTitle(source) {
    return jobPhotoReportCaption(source) || 'Photo';
}
//# sourceMappingURL=jobPhotoCaption.js.map